import "./editorialForms.css";

const propertyTypes = [
  { id: "hotel", name: "Hotel" },
  { id: "hostel", name: "Hostel" },
  { id: "apartment", name: "Apartamento" },
  { id: "resort", name: "Resort" },
  { id: "villa", name: "Villa" },
  { id: "bnb", name: "Pousada" },
];

const amenitiesList = [
  "Wi-Fi Grátis",
  "Piscina",
  "Academia",
  "Estacionamento",
  "Ar Condicionado",
  "Café da Manhã",
  "Restaurante",
  "Bar",
  "Spa",
  "Pet Friendly",
  "Transfer",
  "Lavanderia",
];

export default function BookingForm({ data, onChange }) {
  const handleToggleAmenity = (amenity) => {
    const current = data?.amenities || [];
    if (current.includes(amenity)) {
      onChange({
        ...data,
        amenities: current.filter((a) => a !== amenity),
      });
    } else {
      onChange({
        ...data,
        amenities: [...current, amenity],
      });
    }
  };

  const handlePriceChange = (field, value) => {
    onChange({
      ...data,
      pricePerNight: {
        ...data?.pricePerNight,
        [field]: value,
        currency: data?.pricePerNight?.currency || "BRL",
      },
    });
  };

  return (
    <div className="editorial_form booking_form">
      <div className="editorial_form_section">
        <label>
          Nome da Propriedade <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Hotel Praia Dourada"
          value={data?.propertyName || ""}
          onChange={(e) => onChange({ ...data, propertyName: e.target.value })}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tipo de Propriedade</label>
          <select
            value={data?.propertyType || ""}
            onChange={(e) => onChange({ ...data, propertyType: e.target.value })}
          >
            <option value="">Selecione</option>
            {propertyTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>
            Preço por Noite (R$) <span className="required">*</span>
          </label>
          <input
            type="number"
            placeholder="0.00"
            value={data?.pricePerNight?.amount || ""}
            onChange={(e) =>
              handlePriceChange("amount", parseFloat(e.target.value) || 0)
            }
            min="0"
            step="0.01"
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Descreva a propriedade, localização, diferenciais..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={2000}
          rows={3}
        />
      </div>

      <div className="editorial_form_section">
        <label>Endereço</label>
        <input
          type="text"
          placeholder="Rua, número, bairro"
          value={data?.address || ""}
          onChange={(e) => onChange({ ...data, address: e.target.value })}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Cidade</label>
          <input
            type="text"
            placeholder="Cidade"
            value={data?.city || ""}
            onChange={(e) => onChange({ ...data, city: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>País</label>
          <input
            type="text"
            placeholder="País"
            value={data?.country || "Brasil"}
            onChange={(e) => onChange({ ...data, country: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Check-in</label>
          <input
            type="text"
            placeholder="Ex: 14:00"
            value={data?.checkIn || ""}
            onChange={(e) => onChange({ ...data, checkIn: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Check-out</label>
          <input
            type="text"
            placeholder="Ex: 12:00"
            value={data?.checkOut || ""}
            onChange={(e) => onChange({ ...data, checkOut: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Avaliação (0-10)</label>
          <input
            type="number"
            placeholder="8.5"
            value={data?.rating || ""}
            onChange={(e) =>
              onChange({ ...data, rating: parseFloat(e.target.value) || 0 })
            }
            min="0"
            max="10"
            step="0.1"
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Comodidades</label>
        <div className="genre_chips">
          {amenitiesList.map((amenity) => (
            <span
              key={amenity}
              className={`genre_chip ${
                (data?.amenities || []).includes(amenity) ? "selected" : ""
              }`}
              onClick={() => handleToggleAmenity(amenity)}
            >
              {amenity}
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Políticas</label>
        <div className="editorial_form_checkboxes">
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="petsAllowed"
              checked={data?.policies?.pets || false}
              onChange={(e) =>
                onChange({
                  ...data,
                  policies: { ...data?.policies, pets: e.target.checked },
                })
              }
            />
            <label htmlFor="petsAllowed">Aceita pets</label>
          </div>
          <div className="editorial_form_checkbox">
            <input
              type="checkbox"
              id="smokingAllowed"
              checked={data?.policies?.smoking || false}
              onChange={(e) =>
                onChange({
                  ...data,
                  policies: { ...data?.policies, smoking: e.target.checked },
                })
              }
            />
            <label htmlFor="smokingAllowed">Permite fumar</label>
          </div>
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z" />
        </svg>
        <span>
          Adicione fotos de qualidade dos quartos e áreas comuns para atrair hóspedes.
        </span>
      </div>
    </div>
  );
}
